import { getEmptyImageFields } from '@akin-home/images';
import { Recipe } from '@akin-home/recipes';
import { Meal } from '../types';

export const getRecipeFieldsForMealImport = (
  recipe: Recipe
): Partial<Meal> => ({
  ...getEmptyImageFields(),
  title: recipe.name,
  emoji: recipe.emoji,
  imageUrl: recipe.imageUrl,
  image: recipe.image,
});

export const importRecipeToMeal = (recipe: Recipe, meal: Meal): Meal => {
  const recipes = meal.recipes;

  let data: Partial<Meal> = {};

  if (recipe && !recipes.some((r) => r.id === recipe.id)) {
    if (recipes.length === 0) {
      data = {
        ...data,
        ...getRecipeFieldsForMealImport(recipe),
      };
    }

    data.recipes = [...recipes, recipe];
  }

  return { ...meal, ...data };
};
